"use client";

import useEmblaCarousel from "embla-carousel-react";
import EmblaCarouselAutoplay from "@/components/ui/embla-carousel/embla-carousel-autoplay";
import { Row } from "react-bootstrap";

function SponsorLogosSidenav({ isCollapsed }: { isCollapsed: boolean }) {
  const OPTIONS = { loop: true };
  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS);
  const sponsors = [
    {
      src: "/logos/ai2peat-logo.png",
      text: "AI2Peat Logo",
      url: "https://ai2peat.ie/",
    },
    {
      src: "/logos/ceadar-logo.png",
      text: "CeADAR Logo",
      url: "https://ceadar.ie/",
    },
    {
      src: "/logos/icrag-logo.png",
      text: "ICrag Logo",
      url: "https://www.icrag-centre.org/",
    },
    {
      src: "/logos/research-ireland.png",
      text: "Taighde Éireann - Research Ireland",
      url: "https://www.researchireland.ie/",
    },
    {
      src: "/logos/npws.png",
      text: "NPWS Logo",
      url: "https://www.npws.ie/",
    },
    {
      src: "/logos/eu.png",
      text: "EU Logo",
      url: "https://next-generation-eu.europa.eu",
    },
    {
      src: "/logos/gov-ireland.png",
      text: "Government of Ireland Logo",
      url: "https://www.gov.ie",
    },
    {
      src: "/logos/national-challenge-fund.png",
      text: "National Challenge Fund Logo",
      url: "https://www.sfi.ie/challenges/National-Challenge-Fund/",
    },
  ];
  return (
    <Row>
      <EmblaCarouselAutoplay slides={sponsors} options={OPTIONS} />
    </Row>
  );
}

export default SponsorLogosSidenav;
